import React, { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'
import { GetFilesByParticipantsRes } from '../../../../interfaces/Participant';
import { GetFilesByParticipantsAsync } from '../../../../services/participantServices/ParticipantService';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../../../firebase/AuthProvider';
import { toast } from 'react-toastify';
import { formatFileSize } from '../../../../utilities/fileUtils';
import moment from 'moment';
import { PaginationDto } from '../../../../interfaces/Employee/Employee';
import Pagination from '../../../ui/Pagination/Pagination';
import Loader from '../../loader/Loader';

const RecentFilesPage = () => {
    const { currentUser } = useAuth();
    const { participantId } = useParams();

    const [participantFiles, setParticipantFiles] = useState<GetFilesByParticipantsRes[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [pagination, setPagination] = useState<PaginationDto>({ pageNumber: 1, pageSize: 10 });
    const [fileCount, setFileCount] = useState<number>(0);

    useEffect(() => {
        currentUser?.getIdToken().then(token => {
            if (token) {
                getParticipantFiles(token);
            }
        })
    }, [currentUser, pagination])

    const getParticipantFiles = (token: string) => {
        if (!participantId) return;
        setLoading(true);
        GetFilesByParticipantsAsync(token, participantId, pagination.pageNumber, pagination.pageSize).then((response) => {
            if (response.success) {
                setParticipantFiles(response.data.files);
                setFileCount(response.data.count)
            } else {
                toast.error(response.message);
            }
        }).catch((error) => {
            toast.error(error.message);
        }).finally(() => {
            setLoading(false);
        })
    }

    const onPageChange = (pageNum: number) => {
        setPagination((prev) => ({
            ...prev,
            pageNumber: pageNum
        }))
    }

    const resetPageSize = (pageNumber: number, pageSize: number) => {
        setPagination({
            pageNumber: pageNumber,
            pageSize: pageSize
        })
    }
    return (
        <>
            {loading && <Loader />}
            <div className="common_content_inner mby_t_24">
                <Table responsive className="common_table">
                    <thead>
                        <tr>
                            <th>File Name</th>
                            <th>Size</th>
                            <th>Upload Date</th>
                            <th>Author Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            participantFiles.length === 0 ?
                                (<tr className='text-center'><td colSpan={4}>No Data Found</td></tr>) :
                                (
                                    participantFiles.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.fileName}</td>
                                            <td>{formatFileSize(item.size)}</td>
                                            <td>{moment(item.createDate).format('DD/MM/YYYY')}</td>
                                            <td>{item.authorName}</td>
                                        </tr>
                                    ))
                                )
                        }

                    </tbody>
                </Table>
                {(fileCount && fileCount > 0) ? (
                    <Pagination
                        currentPage={pagination.pageNumber}
                        totalPages={Math.ceil(fileCount / pagination.pageSize)}
                        onPageChange={onPageChange}
                        pageSize={pagination.pageSize}
                        resetPageSize={resetPageSize}
                    />
                ) : <></>}
            </div>
        </>
    )
}

export default RecentFilesPage